import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", { class: "caret" }, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["title", "onClick"]

import { useField } from 'vee-validate'
import IconUI from '@/components/CommonUI/IconUI.vue'
import NotificationUI from '@/components/CommonUI/NotificationUI.vue'
import { ref, toRefs, computed } from 'vue'

interface Props {
  options: DropdownOption[],
  name: string,
  optionsTitle?: string,
  value?: number,
  small?: boolean,
  scrollable?: boolean,
  fullWidth?: boolean,
  label?: string | null,
  labelClass?: string,
  labelTooltipText?: string,
  placeholder?: string,
  toggleClass?: string,
  toggleText?: string,
  disabled?: boolean,
  upperCaseFirstLetter?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownUI',
  props: {
    options: {},
    name: {},
    optionsTitle: { default: '' },
    value: { default: undefined },
    small: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: true },
    label: { default: null },
    labelClass: { default: '' },
    labelTooltipText: { default: '' },
    placeholder: { default: '' },
    toggleClass: { default: '' },
    toggleText: { default: '' },
    disabled: { type: Boolean, default: false },
    upperCaseFirstLetter: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;



const { name, value, options, placeholder, toggleText } = toRefs(props)

const {
  value: selectedOptionId,
  errorMessage,
  errors,
  meta,
  handleChange,
  setTouched,
} = useField(name, undefined, {
  initialValue: value.value,
})

const isOpened = ref(false)

const optionLabel = computed(() => {
  const option = options.value.find(({ id }) => id === selectedOptionId.value)

  return option?.name || placeholder.value || toggleText.value
})
const isShowError = computed(() => !!errors.value.length && !meta.valid)



function selectOption(option: DropdownOption) {
  if (option.disabled) return

  setTouched(true)
  handleChange(option.id)
  emit('update:modelValue', option.id)
}

return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["label", { [_ctx.labelClass]: _ctx.labelClass, 'has-error': isShowError.value }])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.label), 1),
          (_ctx.labelTooltipText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _withDirectives(_createVNode(IconUI, {
                  name: "tooltip",
                  fill: "info"
                }, null, 512), [
                  [_directive_tippy, { content: _ctx.labelTooltipText }]
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown one-line", { small: _ctx.small, open: isOpened.value, 'full-width': _ctx.fullWidth }])
    }, [
      _createElementVNode("a", {
        href: "#",
        title: _unref(toggleText) || _unref(placeholder),
        class: _normalizeClass(["dropdown-toggle truncate-line", {
          'upper-case-for-first-letter': _ctx.upperCaseFirstLetter,
          [_ctx.toggleClass]: _ctx.toggleClass,
          disabled: _ctx.disabled,
        }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass({ placeholder: optionLabel.value === _unref(placeholder) })
        }, _toDisplayString(optionLabel.value), 3),
        _hoisted_3
      ], 10, _hoisted_2),
      _createElementVNode("ul", {
        class: _normalizeClass(["dropdown-menu", _ctx.scrollable ? `dropdown-menu-scrollable` : ``])
      }, [
        (_ctx.optionsTitle)
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass({ 'upper-case-for-first-letter': _ctx.upperCaseFirstLetter })
              }, _toDisplayString(_ctx.optionsTitle), 3)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `${item.name}`
          }, [
            _createElementVNode("a", {
              title: item.name,
              href: "#",
              class: _normalizeClass({ 'upper-case-for-first-letter': _ctx.upperCaseFirstLetter, disabled: item.disabled }),
              onClick: _withModifiers(($event: any) => (selectOption(item)), ["prevent"])
            }, _toDisplayString(item.name), 11, _hoisted_5)
          ]))
        }), 128))
      ], 2)
    ], 2),
    (isShowError.value)
      ? (_openBlock(), _createBlock(NotificationUI, {
          key: 1,
          message: _unref(errorMessage),
          type: "error outline",
          "icon-fill": "error",
          "icon-name": "danger"
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ]))
}
}

})